<section>
  <div
    class="list-of-options pointer-cursor"
    *ngFor="let option of listOfProfileOptions"
    (click)="optionAction(option.type)"
  >
    <h3>{{ option.name }}</h3>
  </div>
</section>
